import { render } from "./WatchPage.vue?vue&type=template&id=3457e500&scoped=true"
import script from "./WatchPage.vue?vue&type=script&lang=js"
export * from "./WatchPage.vue?vue&type=script&lang=js"

import "./WatchPage.vue?vue&type=style&index=0&id=3457e500&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3457e500"]])

export default __exports__